// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * Temporary API for Coding Rules - will be replaced with auto-generated version
 *
 * TODO: Replace with auto-generated version when backend provides OpenAPI spec
 *
 * NOTE: This class is manually created as a temporary solution.
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    SupportCodingRule,
    ProviderCodingRule,
    SupportCodingRuleFromJSON,
    ProviderCodingRuleFromJSON,
} from '../models';

export interface ListSupportCodingRulesRequest {
    limit?: number;
    offset?: number;
}

export interface ListProviderCodingRulesRequest {
    limit?: number;
    offset?: number;
}

/**
 * Coding Rules API
 */
export class CodingRulesApi extends runtime.BaseAPI {

    /**
     * List Support Coding Rules
     * Gets a list of coding rules for support
     */
    async listSupportCodingRulesRaw(requestParameters: ListSupportCodingRulesRequest = {}): Promise<runtime.ApiResponse<SupportCodingRule[]>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding_rules", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCodingRuleFromJSON));
    }

    /**
     * List Support Coding Rules
     * Gets a list of coding rules for support
     */
    async listSupportCodingRules(requestParameters: ListSupportCodingRulesRequest = {}): Promise<SupportCodingRule[]> {
        const response = await this.listSupportCodingRulesRaw(requestParameters);
        return await response.value();
    }

    /**
     * List Provider Coding Rules
     * Gets a list of coding rules for provider
     */
    async listProviderCodingRulesRaw(requestParameters: ListProviderCodingRulesRequest = {}): Promise<runtime.ApiResponse<ProviderCodingRule[]>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding_rules"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/coding/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCodingRuleFromJSON));
    }

    /**
     * List Provider Coding Rules
     * Gets a list of coding rules for provider
     */
    async listProviderCodingRules(requestParameters: ListProviderCodingRulesRequest = {}): Promise<ProviderCodingRule[]> {
        const response = await this.listProviderCodingRulesRaw(requestParameters);
        return await response.value();
    }
}
